module.exports = __webpack_public_path__ + "img/56400.62c32245.jpg";